var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('offer-form',{model:{value:(_vm.offer),callback:function ($$v) {_vm.offer=$$v},expression:"offer"}})}
var staticRenderFns = []

export { render, staticRenderFns }